<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-04-19 10:15:25
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-04-25 15:09:13
 * @FilePath: /dsicm-admin-web/src/views/treatment/components/NavTap/index.vue
-->
<template>
    <div class="nav-tap">
        <el-tabs 
        v-model="editableTabsValue" 
        type="card" 
        closable 
        @tab-remove="removeTab"
        @tab-click="changeHandelTab">
            <el-tab-pane
                v-for="(item,index) in editableTabsData"
                :key="index"
                :label="item.patientName"
                :name="item.patientId"
            >
        </el-tab-pane>
</el-tabs>
    </div>
</template>
<script>
import eventBus from '@/utils/eventBus.js'
export default {
    name:'NavTap',
    props:{
        userTabsData:{
            type:Array,
            default:[]
        }
    },
    data(){
        return{
            editableTabsValue: '',
            editableTabsData: [],
        }
    },

    created() {
        //TODO 在chatUserList 传递的参数
		// eventBus.$on('editableTabsData', (data)=>{
        //     this.editableTabsData = data;
        //     this.editableTabsValue = data[0].id
		// }) 
        if(this.userTabsData.length){
           this.editableTabsValue = this.userTabsData[0].patientId;
        } 
        this.editableTabsData = this.userTabsData;
	},
    watch:{
        userTabsData(newVal,oldVal){
            this.editableTabsValue = newVal[0].patientId;
            this.editableTabsData = newVal;
        }
    },

    methods:{
        /**
         * @description: 删除Tab，如果在最后一个删除，递减ID 请求历史聊天，否则从前往后删除递增 editableTabsValue
         * 删除剩一个的时候禁止删除
         * @param {*} targetName
         * @return {*}
         */
        removeTab(targetName) {
            if(this.editableTabsData.length == 1) return this.$message.error('必须保留一个')
            let tabs = this.editableTabsData;
            let activeName = this.editableTabsValue;
            if (activeName === targetName) {
                tabs.forEach((tab, index) => {
                    if (tab.patientId === targetName) {
                        let nextTab = tabs[index + 1] || tabs[index - 1];
                        if (nextTab) {
                            activeName = nextTab.patientId;
                        }
                    }
                });
            }
            this.editableTabsValue = activeName;
            //TODO 拿到当前选中的用户id 讲这个参数暴露出来
            const tabActive = this.editableTabsData.filter(tab => tab.patientId == activeName)[0];
            this.$emit('tabActive',tabActive)
            this.editableTabsData = this.editableTabsData.filter(tab => tab.patientId !== targetName);
            this.$emit('removeActive',this.editableTabsData);
        },

        /**
         * @description: 点击tabs 定位当前用户到第一条
         * @param {*}
         * @return {*}
         */    
        changeHandelTab(targetName){
            let data = JSON.parse(JSON.stringify(this.editableTabsData[targetName.index]))
            this.$emit('tabActive',data)
            this.editableTabsData.splice(targetName.index,1)
            this.editableTabsData.unshift(data);
            // eventBus.$emit('editableTabsRemove', this.editableTabsData)
        }
    },
}
</script>
<style scoped lang="less">
.nav-tap{
    padding: 0 !important;
    height: 40px;
    .el-tabs{
        & /deep/.el-tabs__header{
            flex: 1 !important;
        }
    }
}
</style>